import { createUseStyles } from 'react-jss';
import { Spacings } from '@picsart/design-system/foundation/spacings';

const useStyles = createUseStyles(
  {
    '@keyframes slideInRight': {
      from: {
        opacity: 0,
        transform: 'translateX(30px)',
      },
      to: {
        opacity: 1,
        transform: 'translateX(0)',
      },
    },
    uploadSection: {
      display: 'flex',
      flexDirection: 'column',
      gap: Spacings.s8,
      // No DS easing match for cubic-bezier(0.16, 1, 0.3, 1) — bespoke "out-expo"-style curve
      animation: '$slideInRight 0.4s cubic-bezier(0.16, 1, 0.3, 1) 0.1s both',
    },
  },
  { name: 'inputs-section' }
);

export default useStyles;
